module.exports = __webpack_public_path__ + "img/ic_warning.50c414cf.svg";